import React from "react";

const LockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M5.33301 5.33333V6.66667H10.6663V5.33333C10.6663 3.86057 9.4724 2.66667 7.99967 2.66667C6.52692 2.66667 5.33301 3.86057 5.33301 5.33333ZM3.99967 6.66667V5.33333C3.99967 3.12419 5.79053 1.33333 7.99967 1.33333C10.2088 1.33333 11.9997 3.12419 11.9997 5.33333V6.66667H12.6663C13.4027 6.66667 13.9997 7.26362 13.9997 8V13.3333C13.9997 14.0697 13.4027 14.6667 12.6663 14.6667H3.33301C2.59663 14.6667 1.99967 14.0697 1.99967 13.3333V8C1.99967 7.26362 2.59663 6.66667 3.33301 6.66667H3.99967ZM3.33301 8H12.6663V13.3333H3.33301V8Z" fill="#A4A3A8"/>
  </svg>
);

export default LockIcon; 